import { apiJson, buildApiUrl } from "./client";

export function getMyConversations() {
  return apiJson("/api/conversations");
}

export function startDirectConversation(otherUserId) {
  return apiJson("/api/conversations/direct", {
    method: "POST",
    body: { otherUserId }
  });
}

export function sendChatRequest(toUserId) {
  return apiJson("/api/conversations/requests", {
    method: "POST",
    body: { toUserId }
  });
}

export function getIncomingChatRequests() {
  return apiJson("/api/conversations/requests/incoming");
}

export function acceptChatRequest(requestId) {
  return apiJson(`/api/conversations/requests/${requestId}/accept`, {
    method: "POST"
  });
}

export function rejectChatRequest(requestId) {
  return apiJson(`/api/conversations/requests/${requestId}/reject`, {
    method: "POST"
  });
}

export function blockUser(userId) {
  return apiJson("/api/conversations/block", {
    method: "POST",
    body: { userId }
  });
}

export function unblockUser(userId) {
  return apiJson("/api/conversations/unblock", {
    method: "POST",
    body: { userId }
  });
}

export function unchatConversation(conversationId) {
  return apiJson(`/api/conversations/${conversationId}/unchat`, {
    method: "POST"
  });
}

export function getBlockedUsers() {
  return apiJson("/api/conversations/blocked-users");
}

export function createGroupConversation(title, memberUserIds) {
  return apiJson("/api/conversations/group", {
    method: "POST",
    body: { title, memberUserIds }
  });
}

export function getConversationMessages(conversationId, take = 100) {
  return apiJson(`/api/conversations/${conversationId}/messages`, {
    query: { take }
  });
}

export function postConversationMessage(conversationId, message) {
  return apiJson(`/api/conversations/${conversationId}/messages`, {
    method: "POST",
    body: message
  });
}

export async function uploadConversationImage(conversationId, file) {
  const form = new FormData();
  form.append("file", file);
  const response = await fetch(buildApiUrl(`/api/conversations/${conversationId}/upload-image`), {
    method: "POST",
    credentials: "include",
    headers: { "X-WillPlay-Request": "1" },
    body: form
  });
  const text = await response.text();
  let data = null;
  if (text) {
    try {
      data = JSON.parse(text);
    } catch {
      data = text;
    }
  }
  return { response, data };
}
